export default __webpack_public_path__ + "static/media/Hand.402749e3.png";